import * as React from "react";
import styled from "styled-components";
import { select, useSelect } from "@hubper/theme";
import Text from "../../elements/Text";

import mergeStyles from "../../util/mergeStyles";

const Base = styled.div`
  padding: ${select.space(0)} ${select.space(3)};
  display: inline-flex;
  align-items: center;
  border-radius: 12px;
  position: relative;
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  status: "success" | "error" | "warning";
  text: string;
};

function StatusTag({ style, className, text, status }: Props, ref: any) {
  const { color } = useSelect();

  const colorIndex = status === "warning" ? 5 : 4;

  return (
    <Base
      ref={ref}
      style={mergeStyles(style, {
        backgroundColor: color([status, colorIndex])
      })}
      className={className}
    >
      <Text fs={-1} c="white">
        {text}
      </Text>
    </Base>
  );
}

export default React.forwardRef(StatusTag);
